import BearCub from "./components/BearCub.js";
import Beaver from "./components/Beaver.js";
import Elephant from "./components/Elephant.js";
import Snoopy from "./components/Snoopy.js";
import Tiger from "./components/Tiger.js";
import Clock from "./components/Clock.js";
import Ruler from "./components/Ruler.js";
import Notepad from "./components/Notepad.js";
import Calendar from "./components/Calendar.js";
import PencilJar from "./components/PencilJar.js";
import Pizza from "./components/Pizza.js";

export const buttonsArray = [
  { text: "Bear Cub", component: <BearCub /> },
  { text: "Elephant", component: <Elephant /> },
  { text: "Beaver", component: <Beaver /> },
  { text: "Tiger", component: <Tiger /> },
  { text: "Snoopy", component: <Snoopy /> },
  { text: "Clock", component: <Clock /> },
  { text: "Ruler", component: <Ruler /> },
  { text: "Notepad", component: <Notepad /> },
  { text: "Calendar", component: <Calendar /> },
  { text: "Pencil Jar", component: <PencilJar /> },
  { text: "Pizza", component: <Pizza /> },
];
